/**
 * Dependent to allbet.js mixins
 *
 */
export default {
  methods : {
    computedBetType (wager, args) {
      var display = wager.betTypCap
      if(wager.betTypId == this.otrBetType) {
        return wager.otrCap
      }

      if(wager.plyTypId != '1' && wager.betTypId != this.mulpBetType) {
        display += (' -' +  wager.plyTypCap)
      }
      if(args) {
        if(args.isBetslip) {
          return display
        }
      }
      return '[' + display + ']'
    },
    computedTeamBet (wager) {
      var display = wager.tbetCap

      if(wager.betTypId == this.htftBetType) {
        var htft = wager.tbet.split("")
        if(htft[0] === 'h' && htft[1] === 'h'){
          display = this.$store.getters.sportAllBetLang['ALL_BET.LBL_HOME'] + ' / ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_HOME']
        }else if(htft[0] === 'h' && htft[1] === 'd'){
          display = this.$store.getters.sportAllBetLang['ALL_BET.LBL_HOME'] + ' / ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_PUSH']
        }else if(htft[0] === 'h' && htft[1] === 'a'){
          display = this.$store.getters.sportAllBetLang['ALL_BET.LBL_HOME'] + ' / ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_AWAY']
        }else if(htft[0] === 'd' && htft[1] === 'h'){
          display = this.$store.getters.sportAllBetLang['ALL_BET.LBL_PUSH'] + ' / '+  this.$store.getters.sportAllBetLang['ALL_BET.LBL_HOME']
        }else if(htft[0] === 'd' && htft[1] === 'd'){
          display = this.$store.getters.sportAllBetLang['ALL_BET.LBL_PUSH'] + ' / ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_PUSH']
        }else if(htft[0] === 'd' && htft[1] === 'a'){
          display = this.$store.getters.sportAllBetLang['ALL_BET.LBL_PUSH'] + ' / ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_AWAY']
        }else if(htft[0] === 'a' && htft[1] === 'h'){
          display = this.$store.getters.sportAllBetLang['ALL_BET.LBL_AWAY'] + ' / ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_HOME']
        }else if(htft[0] === 'a' && htft[1] === 'd'){
          display = this.$store.getters.sportAllBetLang['ALL_BET.LBL_AWAY'] + ' / ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_PUSH']
        }else if(htft[0] === 'a' && htft[1] === 'a'){
          display = this.$store.getters.sportAllBetLang['ALL_BET.LBL_AWAY'] + ' / ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_AWAY']
        }
        return display
      }
      return display
    },
    computedHdp (wager) {
      var hdp = wager.hdp
      //cant use this as dynamic because value might same if the member is viewing either in-play or today
      //if(wager.betTypId == this.hdpBetType || wager.betTypId == this.rhdpBetType) {
      if(wager.betTypId == '1' || wager.betTypId == '8') {
        return hdp
      } else {
        return ''
      }
    }
  }
}



// WEBPACK FOOTER //
// ./resources/wob/vue/mixins/wagersMixins.js